import { render, staticRenderFns } from "./SearchError.vue?vue&type=template&id=72104656&"
import script from "./SearchError.vue?vue&type=script&lang=ts&"
export * from "./SearchError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports